import CryptoJS from 'crypto-js';

export const application_submitted_stages = [
	'application cancelled',
	'application completed',
	'application submitted',
	'conditionally approved',
	'details validation',
	'direct debit',
	'enjoy the benefits',
	'enjoy',
	'final offer accepted',
	'handover',
	'home confirmation',
	'initial offer accepted',
	'installation',
	'offer accepted',
	'offer and system acceptance',
	'product inactive'
];

export const textInputFields = ['text', 'number', 'phone', 'email'];

export const google_route_street_directions = [
	{ code: 'DE', name: 'DEVIATION', description: 'DEVIATION' },
	{ code: 'OP', name: 'OVERPASS', description: 'OVERPASS' },
	{ code: 'CN', name: 'CENTRAL', description: 'CENTRAL' },
	{ code: 'E', name: 'EAST', description: 'EAST' },
	{ code: 'EX', name: 'EXTENSION', description: 'EXTENSION' },
	{ code: 'IN', name: 'INNER', description: 'INNER' },
	{ code: 'LR', name: 'LOWER', description: 'LOWER' },
	{ code: 'ML', name: 'MALL', description: 'MALL' },
	{ code: 'N', name: 'NORTH', description: 'NORTH' },
	{ code: 'NE', name: 'NORTH EAST', description: 'NORTH EAST' },
	{ code: 'NW', name: 'NORTH WEST', description: 'NORTH WEST' },
	{ code: 'OF', name: 'OFF', description: 'OFF' },
	{ code: 'ON', name: 'ON', description: 'ON' },
	{ code: 'OT', name: 'OUTER', description: 'OUTER' },
	{ code: 'S', name: 'SOUTH', description: 'SOUTH' },
	{ code: 'SE', name: 'SOUTH EAST', description: 'SOUTH EAST' },
	{ code: 'SW', name: 'SOUTH WEST', description: 'SOUTH WEST' },
	{ code: 'UP', name: 'UPPER', description: 'UPPER' },
	{ code: 'W', name: 'WEST', description: 'WEST' },
	{ code: 'OT', name: 'OUTER', description: 'OUTER' },
	{ code: 'S', name: 'SOUTH', description: 'SOUTH' },
	{ code: 'SE', name: 'SOUTH EAST', description: 'SOUTH EAST' },
	{ code: 'SW', name: 'SOUTH WEST', description: 'SOUTH WEST' },
	{ code: 'UP', name: 'UPPER', description: 'UPPER' },
	{ code: 'W', name: 'WEST', description: 'WEST' },
];

export const tableTypeList = ['Table', 'Table With Filter'];
export const chartTypeList = ['Bar Chart', 'Stacked Bar Chart'];

export const applicationIdRegex = /^([a-zA-Z0-9_-]+)\.([a-zA-Z0-9_-]+)\.([a-zA-Z0-9._%+-]+)@([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+){0,4}\.[a-zA-Z]{2,})$/;
export const dealIdRegex = /^[0-9]+$/;

export const preventDefaultHref = ['Application-Finalise', 'Application-Resume', 'Print-Document'];

export function titleCase(string: string) {
	let str = string.toLowerCase().split(' ');
	for (let i = 0; i < str.length; i++) {
		str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
	}
	return str.join(' ');
}

export const getButtonColor = (type: string) => {
	switch (type) {
		case 'Primary':
		case 'primary':
			return 'primary';
		case 'Secondary':
		case 'secondary':
			return 'secondary';
		default:
			return '';
	}
};

export const sideScroll = (element: HTMLElement, direction: string, speed: number, distance: number, step: number) => {
	let scrollAmount = 0;
	let slideTimer = setInterval(function () {
		if (direction == 'left') {
			element.scrollLeft -= step;
		} else {
			element.scrollLeft += step;
		}
		scrollAmount += step;
		if (scrollAmount >= distance) {
			window.clearInterval(slideTimer);
		}
	}, speed);
};

export const formatTollFreeNumber = (number: string) => {
	if (number) {
		let formated_number = number.substr(0, 4) + ' ' + number.substr(4, 3) + ' ' + number.substr(7, 4);
		return formated_number;
	}
	return '';
};

export const encryptData = (text: string, phrase: string) => {
	if (text && phrase) {
		const encrypted = CryptoJS.AES.encrypt(JSON.stringify(text), phrase).toString();
		const wordArray = CryptoJS.enc.Base64.parse(encrypted);
		return CryptoJS.enc.Hex.stringify(wordArray);
	}
	return '';
};

export const decryptData = (text: string, phrase: string) => {
	if (text && phrase) {
		// Check if the text is in hex format and its length is valid
		if (!/^[0-9a-fA-F]+$/.test(text) || text.length % 2 !== 0) {
			return text; // Not a valid hex string
		}

		try {
			const wordArray = CryptoJS.enc.Hex.parse(text);
			const toDecrypt = CryptoJS.enc.Base64.stringify(wordArray);
			const decodedString = CryptoJS.AES.decrypt(toDecrypt, phrase).toString(CryptoJS.enc.Utf8);
			const data = decodedString ? JSON.parse(decodedString) : '';
			return data;
		} catch (error) {
			return '';
		}
	}
	return '';
};

export const isExternalLink = (url: string) => {
	const tmp = document.createElement('a');
	tmp.href = url;
	return tmp.host !== window.location.host;
};

export const toSentenceCase = (text: string) => {
	if (text) {
		return text.replace(/\w\S*/g, (txt: string) => {
			return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
		});
	}
	return '';
};

export const getEnvironmentName = (name: string) => {
	if (name) {
		switch (name.toLowerCase()) {
			case 'development':
				return 'dev';

			case 'production':
				return 'prod';

			default:
				return name.toLowerCase();
		}
	}

	return '';
};

export const maskNumber = (numString: string, visibleDigits = 4) => {
	if (numString.length <= visibleDigits) {
		return numString; // No need to mask if the number of visible digits is greater or equal to the length of the number.
	}

	const visiblePart = numString.slice(0, visibleDigits);
	const maskedPart = 'X'.repeat(numString.length - 2 * visibleDigits);

	return visiblePart + maskedPart + numString.slice(-visibleDigits);
};

export const getSubHeadingTag = (parentTag: string, childTag: string) => {
	if (parentTag && childTag) {
		const parentRequestedTag = Number(parentTag?.charAt(1));
		const childRequestedTag = Number(childTag?.charAt(1));

		if (childRequestedTag > parentRequestedTag) {
			return childTag.toLowerCase();
		} else {
			return `h${parentRequestedTag + 1}`;
		}
	}
	return 'none';
};

export const calculateMaxDate = (minAge: number) => {
	const today = new Date();
	const maxDate = new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate());
	return maxDate;
};

export function throttle(callBack: any, delay = 250) {
	let shouldWait = false;

	return (...args: any) => {
		if (shouldWait) return;

		callBack(...args);
		shouldWait = true;
		setTimeout(() => {
			shouldWait = false;
		}, delay);
	};
}

export const uniqueArray = (array: any[] = []) => {
	var a = array.concat();
	for (var i = 0; i < a.length; ++i) {
		for (var j = i + 1; j < a.length; ++j) {
			if (a[i] === a[j]) a.splice(j--, 1);
		}
	}

	return a;
};

export const groupBy = (array: any[], key: string) => {
	// Return the end result
	return array.reduce((result, currentValue) => {
		// If an array already present for key, push it to the array. Else create an array and push the object
		(result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
		// Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
		return result;
	}, {}); // empty object is the initial value for result object
};

export const getbuttonVariant = (variantType: string) => {
	switch (variantType) {
		case 'Primary':
			return 'contained';
		case 'Secondary':
			return 'outlined';
		case 'Primary-Text':
			return 'text';
		case 'Secondary-Text':
			return 'text';
		case 'Link-Text':
			return 'text';
		default:
			return '';
	}
};

export const formatDate = (inputDate: Date | string, format: 'DD/MM/YYYY' | 'MM/DD/YYYY' | 'YYYY/MM/DD' | 'DD-MM-YYYY' | 'MM-DD-YYYY' | 'YYYY-MM-DD') => {
	if (inputDate) {
		const newDate = new Date(inputDate);
		const yyyy = newDate.getFullYear();
		let month = newDate.getMonth() + 1; // Months start at 0!
		let date = newDate.getDate();

		let dd = '';
		let mm = '';
		if (date < 10) dd = '0' + date;
		else dd = date.toString();
		if (month < 10) mm = '0' + month;
		else mm = month.toString();

		if (format === 'MM/DD/YYYY') {
			const formattedDate = mm + '/' + dd + '/' + yyyy;
			return formattedDate;
		} else if (format === 'YYYY/MM/DD') {
			const formattedDate = yyyy + '/' + mm + '/' + dd;
			return formattedDate;
		}
		if (format === 'MM-DD-YYYY') {
			const formattedDate = mm + '-' + dd + '-' + yyyy;
			return formattedDate;
		} else if (format === 'YYYY-MM-DD') {
			const formattedDate = yyyy + '-' + mm + '-' + dd;
			return formattedDate;
		} else if (format === 'DD-MM-YYYY') {
			const formattedDate = dd + '-' + mm + '-' + yyyy;
			return formattedDate;
		} else {
			const formattedDate = dd + '/' + mm + '/' + yyyy;
			return formattedDate;
		}
	}
	return '';
};

export const detectMimeType = async (file: File): Promise<string | null> => {
	const mimeTypes: { [key: string]: string } = {
		ffd8ffe0: 'image/jpeg',
		'89504e47': 'image/png',
		'25504446': 'application/pdf',
	};

	const reader = new FileReader();

	try {
		const renderResult = await new Promise<ArrayBuffer>((resolve, reject) => {
			reader.onload = () => {
				resolve(reader.result?.slice(0, 4) as ArrayBuffer);
			};
			reader.readAsArrayBuffer(file);
		});

		const key = '0123456789abcdef';
		let bytes = new Uint8Array(renderResult);
		let newHex = '';
		let currentChar = 0;
		for (let i = 0; i < bytes.length; i++) {
			currentChar = bytes[i] >> 4;
			newHex += key[currentChar];
			currentChar = bytes[i] & 15;
			newHex += key[currentChar];
		}
		const mimeType = mimeTypes[newHex];
		return mimeType;
	} catch (error) {
		return null;
	}
};

export const validateDropdownOptions = (data: string) => {
	try {
		if (data) {
			const jsonObject = JSON.parse(data);
			if (Array.isArray(jsonObject)) {
				return true;
			}
			return false;
		}
		return false;
	} catch (error) {
		return false;
	}
}

export const generateRandomNumber = () => {
	const array = new Uint32Array(1);
	crypto.getRandomValues(array);
	const randomValue = array[0] / (0xFFFFFFFF + 1);
	return Math.round(randomValue * 100) / 100;
}